import { Injectable } from '@angular/core';
import { IResponseSuccess } from '@app/core/models/response-sucess.model';
import { ErrorHandlerService } from '@app/core/services/error-handler.service';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { TranslateService } from '@ngx-translate/core';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

import { IcsCalendars } from '../../models';
import { IcsCalendarsService } from '../../services/ics-calendars.service';
import { NotificationService } from '../../ui/services/notification.service';

import * as fromActions from './actions';

@Injectable()
export class IcsCalendarsStoreEffects {
  constructor(
    private dataService: IcsCalendarsService,
    private actions$: Actions,
    private errorHandler: ErrorHandlerService,
    private notifications: NotificationService,
    private translate: TranslateService,
  ) {}

  load$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fromActions.loadRequest),
      switchMap(({ params }) => {
        return this.dataService.load(params).pipe(
          map(({ data }: IResponseSuccess<IcsCalendars>) => {
            if (params.reset_key) {
              this.notifications.done(
                this.translate.instant('notifications.generic_success'),
              );
            }
            return fromActions.loadSuccess({
              data,
            });
          }),
          catchError((error) => {
            this.errorHandler.handle(error);
            return of(fromActions.loadFailure(error));
          }),
        );
      }),
    ),
  );
}
